/**
 * 品牌 / 部署套系配置
 * 通过 .env* 中的 VUE_APP_* 切换，构建命令见 package.json：
 *   npm run serve / build          → 养殖装备（默认）
 *   npm run serve:muzhiheng        → 牧智衡本地预览（.env.muzhihengDev）
 *   npm run build:muzhiheng        → 牧智衡正式包（.env.muzhiheng）
 *   npm run serve:yongda           → 永达本地预览（.env.yongdaDev）
 *   npm run build:yongda           → 永达正式包（.env.yongda）
 *
 * 注意：正式打包用的 .env.muzhiheng / .env.yongda 含 NODE_ENV=production，
 * 本地预览请用 serve:* 对应的 *Dev 模式，避免被当成生产编译。
 * 二维码图片放在 public/brand/<套系>/ 下，部署前按需替换即可。
 * 登录页样式通过 theme.* / CSS 变量区分，挂 class：brand-{mode}
 */
const brand = {
	/** 套系标识，对应 VUE_APP_MODE */
	mode: process.env.VUE_APP_MODE || 'production',
	/** 登录页主标题（系统名称） */
	systemName: process.env.VUE_APP_SYSTEM_NAME || '养殖装备物联网管理平台',
	/** 顶部文字 logo 英文（muzhiheng / yongda） */
	systemNameEn: process.env.VUE_APP_SYSTEM_NAME_EN || '',
	/** 登录页副标题 */
	subtitle: process.env.VUE_APP_SYSTEM_SUBTITLE || '智能化 · 自动化 · 数字化养殖管理',
	/** 浏览器标签页标题 */
	pageTitle: process.env.VUE_APP_PAGE_TITLE || '养殖装备IOT物联网平台2.0',
	/** 微信端二维码（public 下路径） */
	qrWechat: process.env.VUE_APP_QR_WECHAT || '/brand/default/ewm.jpg',
	/** 小程序二维码（public 下路径） */
	qrMiniprogram: process.env.VUE_APP_QR_MINIPROGRAM || '/brand/default/xcx.png',
	/** 登录页主题色（构建时注入，登录页以 CSS 变量消费） */
	theme: {
		/** 主色 / 登录按钮 */
		primary: process.env.VUE_APP_THEME_PRIMARY || '#2563eb',
		primaryDark: process.env.VUE_APP_THEME_PRIMARY_DARK || '#1d4ed8',
		/** 图标 / 点缀色 */
		accent: process.env.VUE_APP_THEME_ACCENT || '#06b6d4',
		/** 输入框聚焦、链接悬停等 */
		focus: process.env.VUE_APP_THEME_FOCUS || '#22c55e',
		/** 页面背景渐变 */
		bg: process.env.VUE_APP_THEME_BG ||
			'linear-gradient(135deg, #1d4ed8 0%, #2563eb 25%, #3b82f6 50%, #60a5fa 75%, #93c5fd 100%)',
		/** 登录卡片背景，空则沿用半透明白 */
		cardBg: process.env.VUE_APP_THEME_CARD_BG || '',
		/** 顶部导航背景（空则用默认蓝） */
		headerBg: process.env.VUE_APP_THEME_HEADER_BG ||
			'linear-gradient(to bottom, #258BFF, #0085E4)',
	},
}

export default brand
